import {VueAutosuggest} from 'vue-autosuggest';
import _ from "lodash";
import axios from "axios";

export default {
  name: 'SearchMixin',
  data() {
    return {
      query: '',
      suggestions: [],
      filteredOptions: [{data: []}],
      inputProps: {
        id: "autosuggest__input",
        class: 'form-control bg-light shadow-none',
        placeholder: "Rechercher une matière, une leçon ....."
      },
      searching: false
    }
  },
  components: {
    VueAutosuggest
  },
  computed: {
    hasNoResults() {
      return this.query.length >= 2 && !this.searching && this.filteredOptions.length === 0
    }
  },
  watch: {
    query: _.debounce(function (newVal) {
      // ne pas faire la recherche si le champ ne contient pas au moins 2 caractères et n'est pas vide
      if (newVal.length < 2) {
        this.filteredOptions = []
        return
      }
      this.search()
    }, 300),
  },
  methods: {
    getSuggestionValue(suggestion) {
      return (suggestion.name === 'subject' || suggestion.name === 'chapter') ? suggestion.item.name : suggestion.item.title;
    },
    reset() {
      this.query = ''
      this.filteredOptions = []
    },
    onSelected(option) {
      console.log(option, 'selected');
      if (!option) return
      switch (option.name) {
        case 'subject':
          this.$router.push({name: 'subject', params: {slug: option.item.slug}})
          break
        case 'chapter':
          this.$router.push({
            name: 'subject',
            params: {slug: option.item.subject.slug},
            hash: '#chapter' + option.item.id
          })
          break
        case 'lesson':
          this.$router.push({
            name: 'lesson',
            params: {slug: option.item.slug}
          })
          break
        case 'exercise':
          this.$router.push({
            name: 'exercise',
            params: {id: option.item.id}
          })
          break
        case 'exam':
          this.$router.push({
            name: 'exam',
            params: {slug: option.item.slug}
          })
          break
      }
    },
    search() {
      this.searching = true
      axios.get('/search', {params: {query: this.query}})
        .then(({data}) => {
          this.filteredOptions = data
        })
        .finally(() => this.searching = false)
    }
  }
}
